import React from 'react'
import { getHexColor, OneColorIconProps } from '@/atoms/utils'

export const PerkStarIcon: React.FC<OneColorIconProps> = ({ size = 15.06, color = 'core-gray-800', className }) => {
  const c = getHexColor(color)
  return (
    <svg
      width={size}
      height={size}
      className={className}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 12.95L12.775 15.05C12.975 15.1833 13.175 15.1875 13.375 15.0625C13.575 14.9375 13.6333 14.7583 13.55 14.525L12.5 11.05L15.225 9.1C15.425 8.95 15.4833 8.7625 15.4 8.5375C15.3167 8.3125 15.1583 8.2 14.925 8.2H11.6L10.475 4.55C10.3917 4.31667 10.2333 4.2 10 4.2C9.76667 4.2 9.60833 4.31667 9.525 4.55L8.4 8.2H5.075C4.84167 8.2 4.68333 8.3125 4.6 8.5375C4.51667 8.7625 4.575 8.95 4.775 9.1L7.5 11.05L6.45 14.525C6.36667 14.7583 6.425 14.9375 6.625 15.0625C6.825 15.1875 7.025 15.1833 7.225 15.05L10 12.95ZM10 20C8.61667 20 7.31667 19.7375 6.1 19.2125C4.88333 18.6875 3.825 17.975 2.925 17.075C2.025 16.175 1.3125 15.1167 0.7875 13.9C0.2625 12.6833 0 11.3833 0 10C0 8.61667 0.2625 7.31667 0.7875 6.1C1.3125 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.3125 6.1 0.7875C7.31667 0.2625 8.61667 0 10 0C11.3833 0 12.6833 0.2625 13.9 0.7875C15.1167 1.3125 16.175 2.025 17.075 2.925C17.975 3.825 18.6875 4.88333 19.2125 6.1C19.7375 7.31667 20 8.61667 20 10C20 11.3833 19.7375 12.6833 19.2125 13.9C18.6875 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6875 13.9 19.2125C12.6833 19.7375 11.3833 20 10 20Z"
        fill={c}
      />
    </svg>
  )
}
